module.exports = __webpack_public_path__ + "../static/img/default_device_role.1377a9be.png";